import AbstractClass from '../abstract/abstractClass';
import ProfileInterface from './profileInterface';

export default class ProfileClass
    extends AbstractClass
    implements ProfileInterface
{
    name: string;
    email: string;
    image: string;
    public: boolean;

    constructor(data: Record<string, any>) {
        super(data.id || data.uid);
        this.name = data.name;
        this.email = data.email;
        this.image = data.image;
        this.public = data.public;
    }

    getImage(): string {
        return this.image || '/images/app/default_user.png';
    }

    toJSON(): Record<string, any> {
        return {
            id: this.id,
            data: {
                name: this.name,
                email: this.email,
                image: this.image,
                public: this.public
            }
        };
    }
}
